import PropTypes from 'prop-types';

/**
 * 抽獎加分結果 Dialog：全螢幕遮罩置中顯示剛剛點到的圖片（蓮花／菩提葉）與獲得分數
 */
const RewardResultDialog = ({ imageSrc, points, label, onClose }) => {
    return (
        <div
            className="fixed inset-0 z-500 flex flex-col items-center justify-center p-4"
            style={{ backgroundColor: 'rgba(0,0,0,0.65)' }}
        >
            <div
                className="flex flex-col items-center justify-center rounded-3xl shadow-2xl"
                style={{
                    width: 260,
                    padding: '32px 24px',
                    background: 'linear-gradient(180deg, #FFFBF2 0%, #FDF0E4 100%)',
                    border: '2px solid #C9942B',
                }}
            >
                <h2 className="text-xl font-bold mb-1" style={{ color: '#BC313D' }}>恭喜獲得點數</h2>
                <p className="text-sm mb-4" style={{ color: '#6E625B' }}>您拾取了{label}</p>

                <img
                    src={imageSrc}
                    alt={label}
                    width={120}
                    height={120}
                    draggable={false}
                    style={{ display: 'block', filter: 'drop-shadow(0 6px 12px rgba(0,0,0,0.3))' }}
                />
                <div
                    className="mt-4 font-bold"
                    style={{
                        fontSize: 28,
                        background: 'linear-gradient(135deg, #BC313D, #C9942B)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                    }}
                >
                    +{points}
                </div>
            </div>

            <button
                onClick={onClose}
                className="mt-8 px-10 py-3 rounded-full font-semibold text-white"
                style={{ background: 'linear-gradient(135deg, #BC313D, #A8271E)' }}
            >
                關閉
            </button>
        </div>
    );
};

RewardResultDialog.propTypes = {
    imageSrc: PropTypes.string.isRequired,
    points: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default RewardResultDialog;
